import imageWithText from '@sectionsJS/image-with-text';

$(async () => {
  imageWithText();
});
